import { render, staticRenderFns } from "./CoverPage.vue?vue&type=template&id=76123ffa&scoped=true&"
import script from "./CoverPage.vue?vue&type=script&lang=js&"
export * from "./CoverPage.vue?vue&type=script&lang=js&"
import style0 from "./CoverPage.vue?vue&type=style&index=0&id=76123ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76123ffa",
  null
  
)

export default component.exports